(() => {
  const root = document.documentElement;
  const rootUrl = document.currentScript?.dataset.rootUrl;
  const restrictedCountries = new Set(['FR', 'IT', 'BE', 'NL', 'LU']);
  let activeRequest;

  async function checkCountry() {
    activeRequest?.abort();
    root.dataset.woakGeoip = 'pending';
    if (!rootUrl) {
      root.dataset.woakGeoip = 'unknown';
      return;
    }

    const controller = new AbortController();
    activeRequest = controller;
    const timeout = setTimeout(() => controller.abort(), 5000);

    try {
      const url = new URL(`${rootUrl.replace(/\/?$/, '/')}browsing_context_suggestions.json`, location.origin);
      url.searchParams.set('country[enabled]', 'true');
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
      });
      if (!response.ok) throw new Error('GeoIP request failed');
      const data = await response.json();
      if (activeRequest !== controller || controller.signal.aborted) return;

      const value = data?.detected_values?.country?.handle;
      const country = typeof value === 'string' ? value.trim().toUpperCase() : '';
      if (!country) {
        root.dataset.woakGeoip = 'unknown';
        return;
      }
      root.dataset.woakGeoip = restrictedCountries.has(country) ? 'blocked' : 'allowed';
    } catch {
      if (activeRequest === controller) root.dataset.woakGeoip = 'unknown';
    } finally {
      clearTimeout(timeout);
      if (activeRequest === controller) activeRequest = undefined;
    }
  }

  window.addEventListener('pagehide', () => {
    root.dataset.woakGeoip = 'pending';
    activeRequest?.abort();
    activeRequest = undefined;
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) checkCountry();
  });

  checkCountry();
})();
